// tslint:disable:no-empty-interface

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import Button from '../../../atoms/buttons/Button';

import { LogoBopperWithName } from '../../../atoms/images/Icon';

import './styles.scss';

const classes = new BEM('brand-navigation');

interface IOwnProps {
}

interface IOwnState {
}

export const BlogPagePath = '/blog';
export const PricingPagePath = '/pricing';
export const AboutUsPagePath = '/about';

export class BrandNavigation extends React.Component<IOwnProps, IOwnState> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div {...classes()}>
        <div {...classes('logo-wrapper')}>
          <Button
            wrapperComponent="a"
            variant="icon"
            {...classes('logo')}
            hyperLinkProps={{
              href: '/',
            }}
          >
            <LogoBopperWithName />
          </Button>
          <h1 {...classes('tagline')}>Music Licensing</h1>
        </div>
        <div {...classes('links')}>
          <Button
            wrapperComponent="a"
            hyperLinkProps={{
              href: BlogPagePath,
              target: '_blank',
            }}
          >
            Blog
          </Button>
          <Button
            wrapperComponent="a"
            hyperLinkProps={{
              href: PricingPagePath,
              target: '_blank',
            }}
          >
            Pricing
          </Button>
          <Button
            wrapperComponent="a"
            hyperLinkProps={{
              href: AboutUsPagePath,
              target: '_blank',
            }}
          >
            About Us
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/global/BrandNavigation/index.tsx